import {useMemo, useState} from 'react'
import {useQuery} from 'react-query'
import {getUserById} from '../../../app/modules/apps/data-administration/data-admininstration-list/core/_requests'

export function useFetchCommon({
  isEnabled = true,
  api,
  isDropDown = true,
  label,
  auth = '',
  franchiseId = '',
  showAllResponse = false,
}: any) {
  const responseInfo = useQuery(api, () => getUserById(null, api, auth, franchiseId), {
    cacheTime: 0,
    onError: (err) => {
      // setItemIdForUpdate(undefined)
      console.error(err)
    },
    enabled: isEnabled,
  })

  const accessNestedProperty = (obj, path) => {
    return path.split('[').reduce((acc, key) => {
      return acc && acc[key.replace(']', '')]
    }, obj)
  }
  const {responseData} = useMemo(() => {
    let responseData: any = responseInfo?.data || []
    if (isDropDown && responseData.length) {
      responseData = responseData.map((eachRes) => {
        let labelValue = eachRes
        if (label?.length) {
          label.forEach((property) => {
            if (labelValue && typeof labelValue === 'object') {
              labelValue = property.includes('[')
                ? accessNestedProperty(labelValue, property)
                : labelValue[property]
            } else {
              labelValue = labelValue?.name
            }
          })
        }
        return {
          label: (label?.length ? labelValue : eachRes?.name) || '',
          value: eachRes.id || eachRes.itemId || eachRes.purchaseOrderId || '',
          ...((showAllResponse && {other: eachRes}) || {}),
        }
      })
    }
    return {responseData}
  }, [responseInfo.data])

  return {
    responseData,
    isFetching: responseInfo.isFetching,
  }
}
